import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DraggableDialogPaperComponent from '../../common/components/DraggableDialogPaperComponent';
import { observer } from 'mobx-react';
import { observable } from 'mobx';
import _ from 'lodash';
import { Table, TableHead, TableRow, TableCell, TableBody } from '@material-ui/core';
import { Typography } from '@material-ui/core';
import { TextField } from '@material-ui/core';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import { Editor } from '@tinymce/tinymce-react';

class TestParserOutputDialog extends Component {

  render () {
    const props = this.props,
      { store } = props;

    return (
      <Dialog
        open={props.open}
        // onClose={handleClose}
        PaperComponent={DraggableDialogPaperComponent}
        aria-labelledby="draggable-dialog-title"
        maxWidth={"md"}
      // fullWidth={true}
      >

        <DialogContent >
          <Typography variant="h6">Output</Typography>
          {
            !props.hideParserId &&
              <Typography variant="body1"> Matched Parser : {props.parserId !== null ? "Parser " + (props.parserId - - 1) : "No parser matched"} </Typography>          
          }
          <Table className="test_parser_output_table">
            <TableBody>
              <TableRow>
                {props.values &&
                  Object.entries(props.values[0] || []).map(([key, val]) => {
                    return <TableCell key={key} > <Typography variant="h6">{key}</Typography> </TableCell>;
                  })
                }
              </TableRow>
              {
                props.values && props.values.map((row, key) => {
                  return (<TableRow >
                    {row &&
                      Object.entries(row).map(([key, val]) => {
                        return (
                          <TableCell key={key} >
                            <Typography variant="body1"> {val ? val : "empty"} </Typography>
                          </TableCell>
                        );
                      })
                    }
                  </TableRow>);
                })
              }

            </TableBody>
          </Table>
          {props.parserId !== null && props.values && props.values.length == 0 &&
            <Typography variant="body1"> No Data </Typography>
          }
        </DialogContent>
        <DialogActions>

          <Button onClick={props.onClose} color="primary">
            Close
            </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default observer(TestParserOutputDialog);
